import { inject, Injectable } from '@angular/core';

import { TranslationStrategyFactory } from './translation-strategy.factory';

@Injectable({ providedIn: 'root' })
export class ScopedTranslocoLoaderService {
  private strategy = inject(TranslationStrategyFactory).getStrategy();

  async loadTranslation(scope: string, lang: string): Promise<any> {
    return this.strategy.loadScoped(scope, lang);
  }
}
